import {MathUtils} from "../../utils/MathUtils";


export interface SliceDictionary {
    [index:string]:SliceData[];
}


export interface SliceData {
    swooshName:string;
    x:number;
    y:number;
    rotation:number;
    sliceAbove:string;
    sliceBehind:string;
    klinkX?:number;
    klinkY?:number;
    turn?:string;
    switchSliceAssets?:boolean;
}

/**
 * Class description
 *
 * created on 2017-02-01
 * @author jowa
 */
export class SlicePairs {

    public static SLICE_PAIRS:SliceDictionary = {
        "L1" : [
            {
                swooshName : "swoosh2",
                x : -8,
                y : 3,
                rotation : 0.658,
                sliceBehind : "L1_slice1_behind",
                sliceAbove : "klink",
                klinkX : -14,
                klinkY : 91,
                turn : "left"
            },
            {
                swooshName : "swoosh2",
                x : 7,
                y : -121,
                rotation : 1.8159999999999998,
                sliceBehind : "L1_slice1_behind",
                sliceAbove : "klink",
                klinkX : -31,
                klinkY : -41,
                turn : "right"
            }
        ],
        "L2" : [
            {
                swooshName : "swoosh2",
                x : -33,
                y : 2,
                rotation : 0.30799999999999983,
                sliceBehind : "L2_slice1_behind",
                sliceAbove : "klink",
                klinkX : -20,
                klinkY : 102,
                turn : "left"
            },
            {
                swooshName : "swoosh2",
                x : 16,
                y : -121,
                rotation : 1.42,
                sliceBehind : "L2_slice1_behind",
                sliceAbove : "klink",
                klinkX : -13,
                klinkY : -40,
                turn : "right"
            }
        ],
        "L3" : [
            {
                swooshName : "swoosh2",
                x : -43,
                y : 0,
                rotation : 0,
                sliceBehind : "L3_slice1_behind",
                sliceAbove : "klink",
                klinkX : -22,
                klinkY : 94,
                turn : "left"
            },
            {
                swooshName : "swoosh2",
                x : 27,
                y : -78,
                rotation : 2.006,
                sliceBehind : "L3_slice1_behind",
                sliceAbove : "klink",
                klinkX : -16,
                klinkY : -23,
                turn : "right"
            }
        ],
        "L4" : [
            {
                swooshName : "swoosh2",
                x : -50,
                y : -15,
                rotation : 0,
                sliceBehind : "L4_slice1_behind",
                sliceAbove : "klink",
                klinkX : -18,
                klinkY : 79,
                turn : "left"
            },
            {
                swooshName : "swoosh2",
                x : 29,
                y : -69,
                rotation : 1.712,
                sliceBehind : "L4_slice1_behind",
                sliceAbove : "klink",
                klinkX : -11,
                klinkY : 6,
                turn : "right"
            }
        ],
        "M1" : [
            {
                swooshName : "swoosh1",
                x : 1,
                y : -46,
                rotation : 0.054,
                sliceBehind : "M1_slice1_behind",
                sliceAbove : "M1_slice1_above"
            },
            {
                swooshName : "swoosh4",
                x : -26,
                y : -16,
                rotation : 0.138,
                sliceBehind : "M1_slice1_behind",
                sliceAbove : "M1_slice1_above"
            },
            {
                swooshName : "swoosh2",
                x : -19,
                y : -77,
                rotation : 0.442,
                sliceBehind : "M1_slice2_behind",
                sliceAbove : "M1_slice2_above"
            },
            {
                swooshName : "swoosh3",
                x : 12,
                y : 3,
                rotation : 6.139185307179586,
                sliceBehind : "M1_slice2_behind",
                sliceAbove : "M1_slice2_above"
            },
            {
                swooshName : "swoosh2",
                x : 3,
                y : -91,
                rotation : 1.074,
                sliceBehind : "M1_slice3_behind",
                sliceAbove : "M1_slice3_above"
            },
            {
                swooshName : "swoosh3",
                x : 0,
                y : 0,
                rotation : 0,
                sliceBehind : "M1_slice3_behind",
                sliceAbove : "M1_slice3_above"
            },
            {
                swooshName : "swoosh4",
                x : -4,
                y : -15,
                rotation : 0,
                sliceBehind : "M1_slice3_behind",
                sliceAbove : "M1_slice3_above"
            }
        ],
        "M2" : [
            {
                swooshName : "swoosh2",
                x : 58,
                y : -59,
                rotation : 1.492,
                sliceBehind : "M2_slice1_behind",
                sliceAbove : "M2_slice1_above"
            },
            {
                swooshName : "swoosh3",
                x : 0,
                y : 0,
                rotation : 5.965185307179587,
                sliceBehind : "M2_slice1_behind",
                sliceAbove : "M2_slice1_above"
            },
            {
                swooshName : "swoosh4",
                x : 7,
                y : -7,
                rotation : 0.322,
                sliceBehind : "M2_slice1_behind",
                sliceAbove : "M2_slice1_above"
            },
            {
                swooshName : "swoosh2",
                x : 64,
                y : -7,
                rotation : 1.804,
                sliceBehind : "M2_slice2_behind",
                sliceAbove : "M2_slice2_above"
            },
            {
                swooshName : "swoosh3",
                x : 52,
                y : -5,
                rotation : 4.417185307179587,
                sliceBehind : "M2_slice2_behind",
                sliceAbove : "M2_slice2_above"
            },
            {
                swooshName : "swoosh4",
                x : 29,
                y : 7,
                rotation : 1.3820000000000001,
                sliceBehind : "M2_slice2_behind",
                sliceAbove : "M2_slice2_above"
            },
            {
                swooshName : "swoosh2",
                x : -28,
                y : -7,
                rotation : 0,
                sliceBehind : "M2_slice3_behind",
                sliceAbove : "M2_slice3_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh3",
                x : 33,
                y : 40,
                rotation : 5.395185307179585,
                sliceBehind : "M2_slice3_behind",
                sliceAbove : "M2_slice3_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh4",
                x : -17,
                y : 5,
                rotation : 1.668,
                sliceBehind : "M2_slice3_behind",
                sliceAbove : "M2_slice3_above",
                switchSliceAssets : true
            }
        ],
        "M3" : [
            {
                swooshName : "swoosh2",
                x : 43,
                y : -55,
                rotation : 1.27,
                sliceBehind : "M3_slice1_behind",
                sliceAbove : "M3_slice1_above"
            },
            {
                swooshName : "swoosh3",
                x : 17,
                y : 16,
                rotation : 5.663185307179586,
                sliceBehind : "M3_slice1_behind",
                sliceAbove : "M3_slice1_above"
            },
            {
                swooshName : "swoosh4",
                x : 10,
                y : -16,
                rotation : 0,
                sliceBehind : "M3_slice1_behind",
                sliceAbove : "M3_slice1_above"
            },
            {
                swooshName : "swoosh2",
                x : -26,
                y : -27,
                rotation : 1.038,
                sliceBehind : "M3_slice2_behind",
                sliceAbove : "M3_slice2_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh3",
                x : -14,
                y : 63,
                rotation : 6.0871853071795865,
                sliceBehind : "M3_slice2_behind",
                sliceAbove : "M3_slice2_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh4",
                x : -20,
                y : 43,
                rotation : 0.594,
                sliceBehind : "M3_slice2_behind",
                sliceAbove : "M3_slice2_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh2",
                x : 16,
                y : -93,
                rotation : 0.358,
                sliceBehind : "M3_slice3_behind",
                sliceAbove : "M3_slice3_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh3",
                x : 14,
                y : -21,
                rotation : 0,
                sliceBehind : "M3_slice3_behind",
                sliceAbove : "M3_slice3_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh4",
                x : 18,
                y : -22,
                rotation : 0,
                sliceBehind : "M3_slice3_behind",
                sliceAbove : "M3_slice3_above",
                switchSliceAssets : true
            }
        ],
        "M4" : [
            {
                swooshName : "swoosh2",
                x : 20,
                y : -72,
                rotation : 1.012,
                sliceBehind : "M4_slice1_behind",
                sliceAbove : "M4_slice1_above"
            },
            {
                swooshName : "swoosh3",
                x : 0,
                y : 0,
                rotation : 0.222,
                sliceBehind : "M4_slice1_behind",
                sliceAbove : "M4_slice1_above"
            },
            {
                swooshName : "swoosh4",
                x : 14,
                y : -33,
                rotation : 0,
                sliceBehind : "M4_slice1_behind",
                sliceAbove : "M4_slice1_above"
            },
            {
                swooshName : "swoosh1",
                x : -40,
                y : -30,
                rotation : 3.6051853071795867,
                sliceBehind : "M4_slice2_behind",
                sliceAbove : "M4_slice2_above"
            },
            {
                swooshName : "swoosh2",
                x : -76,
                y : -44,
                rotation : 5.999185307179586,
                sliceBehind : "M4_slice2_behind",
                sliceAbove : "M4_slice2_above"
            },
            {
                swooshName : "swoosh3",
                x : 12,
                y : -19,
                rotation : 4.873185307179587,
                sliceBehind : "M4_slice2_behind",
                sliceAbove : "M4_slice2_above"
            },
            {
                swooshName : "swoosh4",
                x : -11,
                y : -17,
                rotation : 0.854,
                sliceBehind : "M4_slice2_behind",
                sliceAbove : "M4_slice2_above"
            },
            {
                swooshName : "swoosh1",
                x : -36,
                y : -43,
                rotation : 3.605185307179587,
                sliceBehind : "M4_slice3_behind",
                sliceAbove : "M4_slice3_above"
            },
            {
                swooshName : "swoosh2",
                x : 23,
                y : -12,
                rotation : 1.9639999999999997,
                sliceBehind : "M4_slice3_behind",
                sliceAbove : "M4_slice3_above"
            },
            {
                swooshName : "swoosh3",
                x : 11,
                y : -17,
                rotation : 5.083185307179587,
                sliceBehind : "M4_slice3_behind",
                sliceAbove : "M4_slice3_above"
            },
            {
                swooshName : "swoosh4",
                x : -16,
                y : -18,
                rotation : 0.786,
                sliceBehind : "M4_slice3_behind",
                sliceAbove : "M4_slice3_above"
            }
        ],
        "W" : [],
        "W2" : [
            {
                swooshName : "swoosh2",
                x : 24,
                y : -43,
                rotation : 1.7,
                sliceBehind : "W2_slice1_behind",
                sliceAbove : "W2_slice1_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh3",
                x : -3,
                y : 27,
                rotation : 6.065185307179586,
                sliceBehind : "W2_slice1_behind",
                sliceAbove : "W2_slice1_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh4",
                x : -40,
                y : -10,
                rotation : 1.066,
                sliceBehind : "W2_slice1_behind",
                sliceAbove : "W2_slice1_above",
                switchSliceAssets : true
            },
            {
                swooshName : "swoosh2",
                x : -6,
                y : -60,
                rotation : 0.868,
                sliceBehind : "W2_slice2_behind",
                sliceAbove : "W2_slice2_above"
            },
            {
                swooshName : "swoosh3",
                x : -2,
                y : 23,
                rotation : 0,
                sliceBehind : "W2_slice2_behind",
                sliceAbove : "W2_slice2_above"
            },
            {
                swooshName : "swoosh4",
                x : -10,
                y : -18,
                rotation : 1.844,
                sliceBehind : "W2_slice2_behind",
                sliceAbove : "W2_slice2_above"
            },
            {
                swooshName : "swoosh2",
                x : 29,
                y : -14,
                rotation : 1.9980000000000002,
                sliceBehind : "W2_slice3_behind",
                sliceAbove : "W2_slice3_above"
            },
            {
                swooshName : "swoosh3",
                x : 20,
                y : -23,
                rotation : 5.205185307179586,
                sliceBehind : "W2_slice3_behind",
                sliceAbove : "W2_slice3_above"
            },
            {
                swooshName : "swoosh4",
                x : -36,
                y : -35,
                rotation : 1.6460000000000001,
                sliceBehind : "W2_slice3_behind",
                sliceAbove : "W2_slice3_above"
            }

        ],
        "W3" : [
            {
                swooshName : "swoosh1",
                x : -31,
                y : -47,
                rotation : 3.745185307179586,
                sliceBehind : "wildSushi_slice1_behind",
                sliceAbove : "wildSushi_slice1_above"
            },
            {
                swooshName : "swoosh3",
                x : 0,
                y : 0,
                rotation : 6.0791853071795865,
                sliceBehind : "wildSushi_slice1_behind",
                sliceAbove : "wildSushi_slice1_above"
            },
            {
                swooshName : "swoosh4",
                x : -30,
                y : -9,
                rotation : 0.936,
                sliceBehind : "wildSushi_slice1_behind",
                sliceAbove : "wildSushi_slice1_above"
            },
            {
                swooshName : "swoosh1",
                x : -6,
                y : -22,
                rotation : 5.211185307179586,
                sliceBehind : "wildSushi_slice2_behind",
                sliceAbove : "wildSushi_slice2_above"
            },
            {
                swooshName : "swoosh2",
                x : -25,
                y : -49,
                rotation : 1.032,
                sliceBehind : "wildSushi_slice2_behind",
                sliceAbove : "wildSushi_slice2_above"
            },
            {
                swooshName : "swoosh3",
                x : -27,
                y : 22,
                rotation : 0.188,
                sliceBehind : "wildSushi_slice2_behind",
                sliceAbove : "wildSushi_slice2_above"
            },
            {
                swooshName : "swoosh1",
                x : 6,
                y : -14,
                rotation : 5.2731853071795864,
                sliceBehind : "wildSushi_slice3_behind",
                sliceAbove : "wildSushi_slice3_above"
            },
            {
                swooshName : "swoosh3",
                x : -9,
                y : 18,
                rotation : 6.269185307179586,
                sliceBehind : "wildSushi_slice3_behind",
                sliceAbove : "wildSushi_slice3_above"
            }
        ]
    };

    public static getRandomSliceForSym(symName:string):SliceData {
        let randomInt = MathUtils.randomIntFromInterval(0, SlicePairs.SLICE_PAIRS[symName].length - 1);
        return SlicePairs.SLICE_PAIRS[symName][randomInt];
    }


}